"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = void 0;
// this file is autogenerated - do not edit
exports.version = "2.0.0-3";
//# sourceMappingURL=version.js.map